import { Component, EventEmitter, Output, HostListener } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-modal-popup',
  imports: [RouterModule],
  standalone: true,
  templateUrl: './modal-popup.component.html',
  styleUrl: './modal-popup.component.scss',
})
export class ModalPopupComponent {
  @Output() close = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    this.close.emit();
  }

  onClose() {
    this.close.emit();
  }
}
